export default __webpack_public_path__ + "cc108dd7fab6daf84fae55ee9821ad3e.svg";